import { combineReducers } from 'redux'
import bookDrawer from './reducer/booksDrawer'

export default combineReducers({
  bookDrawer,
})
